const AvatarConvention = ({ height = 60, width = 60, profileImageUrl }) => {
  const style = {
    height: `${height}px`,
    width: `${width}px`,
    backgroundColor: '#bdbdbd',
    borderRadius: '50%',
    display: 'flex', 
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    color: '#fff',
  };

  return profileImageUrl ? (
    <img
      style={{
        ...style,
        objectFit: 'cover',
      }}
      src={profileImageUrl}
      alt="Profile"
    />
  ) : (
    <div style={style}>?</div>
  );
};

export default AvatarConvention;